<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() | translate }}</h3>
    </div>
    <mat-form-field *ngIf="data.viewMode" appearance="standard" style="width: 80px !important">
      <mat-select
        [placeholder]="'FORMS_TEMPLATES_MODULE.FORM.SCHEMA.VERSION_0' | translate"
        [value]="data.form?.version"
        (selectionChange)="handleVersionChange($event.value)"
      >
        <mat-option *ngFor="let version of versions" [value]="version"
          >Version {{ version }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <div *ngIf="!data.viewMode" class="d-flex align-items-center">
      <div style="width: 200px !important">
        <kt-general-autocomplete
          #formAutocomplete
          [label]="'FORMS_TEMPLATES_MODULE.FORM.SCHEMA.FORM' | translate"
          [appearance]="'standard'"
          [dataPath]="'data'"
          [control]="formAutocomplete"
          [loadItemsFunction]="getFormAutocomplete"
          [optionFormatter]="formatFormOption"
          [valueFormatter]="formatFormOption"
          [change]="handleFormChange.bind(this)"
          [required]="false"
          [readOnly]="!!data.form?.id"
        ></kt-general-autocomplete>
      </div>
      <mat-form-field appearance="standard" style="width: 80px !important" class="ml-4">
        <mat-label *ngIf="!formAutocomplete.value">{{
          'FORMS_TEMPLATES_MODULE.FORM.VERSION' | translate
        }}</mat-label>
        <mat-select
          #versionSelect
          [placeholder]="'FORMS_TEMPLATES_MODULE.FORM.SCHEMA.VERSION_0' | translate"
          [disabled]="!formAutocomplete.value"
          [value]="formAutocomplete.value?.version"
        >
          <mat-option *ngFor="let version of versions" [value]="version"
            >Version {{ version }}</mat-option
          >
        </mat-select>
      </mat-form-field>
      <button
        mat-raised-button
        matTooltip="Copy Schema"
        class="btn btn-sm btn-icon btn-primary ml-4"
        (click)="copySchema($event)"
      >
        <span class="fa fa-copy"></span>
      </button>
    </div>
  </div>
  <div class="card-body scroll" [perfectScrollbar]="{ wheelPropagation: false }">
    <formio *ngIf="data.viewMode && schemaReady" [form]="schema" [readOnly]="true"></formio>
    <form-builder
      *ngIf="!data.viewMode && schemaReady"
      [form]="prevSchema"
      [options]="{ noDefaultSubmitButton: true }"
      (change)="handleSchemaChange($event.form)"
    ></form-builder>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      *ngIf="!data.viewMode"
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
